<template>
	<!-- 招聘 -->
	<div class="content1">  
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		<div class="zp-hire">
			<img src="../../public/menu/招聘.png" alt="">
			<!-- <div>客赢共兴 协作担当</div>
			<div>创新拼搏 追求卓越</div> -->
		</div>
		<!-- 加入我们 -->
		<div class="jr">
			<div class="jr-h">欢迎加入我们</div>
			<!-- <div class="jr-b">查看职位</div> -->
			<div class="zw-table-wrap">
			    <table class="expandable-table">
			      <thead>
			        <tr>
			          <th>部门</th>
			          <th>岗位名称</th>
			          <th>专业</th>
			          <th>学历要求</th>
					  <th>工作年限</th>
					  <th>HR邮箱</th>
					  <th>电话</th>
					  <!-- <th>公司邮箱</th> -->
					  <th></th>
			        </tr>
			      </thead>
			      <tbody>
			        <template v-for="(item, index) in tableData" :key="item.id">
			          <tr @click="toggleExpand(index)" class="simple-intro" :class="item.isshow?'zw-tr-selected':''">
			            <td>{{ item.recruitOffice }}</td>
			            <td>{{ item.recruitName }}</td>
			            <td>{{ item.recruotSpeciality }}</td>
						<td>{{ item.recruitEducation }}</td>
						<td>{{ item.recruitYears }}</td>
						<td>hr@zgeec.com</td>
						<td>15397151355</td>
			            <td>
			              <button :class="item.isshow==false?'':'button-jian'">
			                {{ item.isshow==false? '+' : '─' }}
			              </button>
			            </td>
			          </tr>
			          <tr v-if="item.isshow === true" class="detail-row">
			            <td colspan="8">
			              <div class="detail-content">
			                <h4>岗位职责</h4>
			                <p v-html="item.recruitIntroduce"></p>
							<h4>任职要求</h4>
							<p v-html="item.recruitDemand"></p>
			              </div>
			            </td>
			          </tr>
			        </template>
			      </tbody>
			    </table>
			  </div>
		</div>
		<!-- <div class="gz">
			<div class="gz-h">
				在中概电力工作
			</div>
			<div class="gz-c">
				<img class="gz-c-l" src="../../public/imgs/home/编组 6@2x.png" alt="">
				<div class="gz-c-m">
					<div class="item">
						<div class="item-h">
							<img src="../../src/assets/hire/4161740035142_.pic.jpg" alt="">
							<div>李白</div>
						</div>
						<div class="item-f">
							群星闪耀，汇聚成光！这里繁星向荣，熠熠生辉，团队齐心，共铸理想。
							<div>很幸运成为曦智的一员！努力打造一流的软件栈！</div>
						</div>
						<img class="item-h-img" src="../../public/imgs/uuu.png" alt="" />
					</div>
					<div class="item">
						<div class="item-h">
							<img src="../../src/assets/hire/4171740035165_.pic.jpg" alt="">
							<div>Sophia</div>
						</div>
						<div class="item-f">
							 很高兴能加入中概电力，专业的团队、有影响力的产品、自由融洽的氛围让工作充满激情和幸福感。在这里每个人都是不可或缺的一份子，作为电力工程师，今后将继续做好工作，并与公司一起健康成长、见证其发展壮大，我们要好好维护他！ 
						</div>
						<img class="item-h-img" src="../../public/imgs/uuu.png" alt="" />
					</div>
				</div>
				<img class="gz-c-r" src="../../public/imgs/home/编组 6@2x(1).png" alt="">
			</div>
		</div>
		<div class="ry">
			<div class="ry-h">
				公司福利
			</div>
			<div class="ry-fl">
				<div class="ry-fl-img">
					<img class="img1" src="../../public/imgs/11111.png" alt="" />
					<img class="img2" src="../../public/imgs/22222.png" alt="" />
					<img class="img3" src="../../public/imgs/33333.png" alt="" />
					<img class="img4" src="../../public/imgs/44444.png" alt="" />
				</div>
				<div class="ry-fl-s">
					<div class="item">
						· 中概友会
						<div>智享学习、节庆福利、生日聚会、免费零食</div>
					</div>
					<div class="item">
						· 活力中概
						<div>开心运动会、团建年会、家庭开放日、活动聚餐</div>
					</div>
					<div class="item">
						· 健康解压
						<div>福利假期、健康体检、内购高端团险</div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- 加入我们 -->
		<!-- <div class="jr">
			<div class="jr-h">欢迎加入我们</div>
			<div class="jr-b">查看职位</div>
		</div> -->

		<footer1></footer1>
		
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
	  hirelist
	} from '@/api/home.js';
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import footer1 from "@/components/footer.vue";
	export default {
		components: {
			mobilemenu,
			header1,
			footer1
		},
		data() {
			return {
				pathname:"hire",
				isShowMobile:false,
				tableData:[],
				expandedRow: null // 当前展开的行索引，null表示没有展开的行
			}
		}, 
		created() {
			this.getZpList()
		},  
		methods: {
			getZpList(){
				hirelist({
					pageNum: 1,
					pageSize:100
				}).then(res => {
				  if (res.data.code == 200) {
				    this.tableData = res.data.rows
					for(var i=0;i<this.tableData.length;i++){
						this.tableData[i].isshow = false
					}
				  }
				})
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			},
			toggleExpand(index) {
				this.tableData[index]['isshow'] = !this.tableData[index]['isshow']
			}
		}
	}
</script>

<style lang="scss" scoped>
	.content1 {
		.zp-hire {
			width: 100%;
			// display: flex;
			// flex-direction: column;
			// justify-content: center;
			// align-items: center;
			// background-color: #888;
			position: relative;

			img {
				// height: auto;	
				// min-height: 160px;
				// width: 100%;
				// z-index: 0;
				// object-fit: fill;
			}

			div {
				font-family: AlibabaPuHuiTi-Regular;
				font-weight: 400;
				color: #FFFFFF;
				// position: relative;
				z-index: 3;
			}
		}

        .jr {
			background-color: white;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			
			.jr-h {
				font-weight: 500;
				color: #332C2B;
			}
			.jr-b {
				cursor: pointer;
				border: 1px solid #22A3D3;
				color: #22A3D3;
				text-align: center;
			}
			.jr-b:hover {
				background-color: #22A3D3;
				color:white;
			}
		}
	
	    // 资质荣誉
	    .gz {
	    	background-color: #FFFFFF;
	    	display: flex;
	    	flex-direction: column;
	    	justify-content: center;
	    	align-items: center;
	    	box-sizing: border-box;
			background-image: linear-gradient(180deg, #008d8e26 0%, #ffffff26 21%);
			
			.gz-h {
				text-align: center;
				
				font-weight: 500;
				color: #332C2B;
			}
	    
	    	.gz-c {
				display: lex;
				justify-content: space-between;
				align-items: center;
				.gz-c-l, .gz-c-r {
					cursor: pointer;
				}
				.gz-c-m {
					justify-content: space-between;
					.item {
						transition: transform 0.3s;
						background-color: #22A3D3;
						box-sizing: border-box;
						.item-h {
							display: flex;
							justify-content: flex-end;
							align-items: center;
							img {
								
							}
							div {
								color: white;
							}
						}
						.item-f {
							color: white;
							opacity: 0.8;
						}
					}
					.item:hover {
       transition: width 0.3s, height 0.3s;
       transform: scale(0.95);
       
      }

				}
				
				
	    	}
		}
		.ry {
			background-image: linear-gradient(246deg, #00C1C1 0%, #22A3D3 100%, #22A3D3 100%);
			display: flex;
			flex-direction: column;
			justify-content: center;
		    .ry-h {
		    	text-align: center;
		    	color: #fff;
		    }
			
			.ry-fl {
				
				margin: 0 auto;
				display: flex;
				align-items: center;
				
				.ry-fl-img {
					
					position: relative;
					.img1 {
						position: absolute;
						
					}
					.img2 {
						position: absolute;
						
					}
					.img3 {
						position: absolute;
					
					}
					.img4 {
						position: absolute;
						
					}
				}
				.ry-fl-s {
					display: flex;
					flex-direction: column;
					justify-content: center;
					color: white;
					.item {
						width: 100%;
						div {
							opacity: 0.65;
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #FFFFFF;
						}
					}
				}
			}
		}
	}
	
	
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
			.zp-hire {
				width: 100%;
				// height: 400px;
				display: flex;
		
				img {
					width: 100%;
					// min-height: 400px;
					height: auto;
				}
		
				div {
					font-weight: 400;
					font-size: 48px;
					z-index: 3;
				}
			}
		
		    .jr {
				width: 100%;
				// height: 296px;
				display: flex;
				padding:40px 0;
				.jr-h {
					font-weight: 500;
					font-size: 48px;
				}
				.jr-b {
					width: 15%;
					height: 63px;
					margin-top: 39px;
					border-radius: 31px;
					line-height: 63px;
				}
			}
		
		    // 资质荣誉
		    .gz {
		    	width: 100%;
		    	display: flex;
		    	padding-bottom: 80px;
				
				.gz-h {
					width: 100%;
					height: 180px;
					line-height: 180px;
					font-size: 28px;
				}
		    
		    	.gz-c {
		    		width: 1200px;
					display: flex;
					.gz-c-l, .gz-c-r {
						width: 64px;
						height: 64px;
					}
					.gz-c-m {
						width: calc(100% - 220px);
						display: flex;
						.item {
							width: 48%;
							padding: 40px 40px 70px;
							border-radius: 10px;
							position: relative;
							.item-h {
								display: flex;
								img {
									width: 64px;
									height: 64px;
									border-radius: 32px;
								}
								div {
									font-size: 22px;
									margin-left: 30px;
									width: calc(100% - 104px);
								}
							}
							.item-f {
								font-size: 16px;
								margin-left: 104px;
								width: calc(100% - 104px);
								height: 160px;
								margin-bottom: 24px;
							}
							.item-h-img {
								width: 30px;
								width: 30px;
								position: absolute;
								bottom: 40px;
								right: 40px;
							}
						}
					}
					
					
		    	}
			}
			.ry {
				width: 100%;
				height: 720px;
				padding-bottom: 20px;
			    .ry-h {
			    	width: 100%;
			    	height: 120px;
			    	line-height: 120px;
			    	font-weight: 500;
			    	font-size: 28px;
			    }
				.ry-fl {
					width: 1200px;
					margin: 0 auto;
					justify-content: space-between;
					
					.ry-fl-img {
						width: 620px;
						height: 400px;
						.img1 {
							top: 18px;
							left: 0;
							width: 240px;
							height: 240px;
						}
						.img2 {
							top: 0px;
							left: 270px;
							width: 180px;
							height: 180px;
						}
						.img3 {
							top: 266px;
							left: 120px;
							width: 180px;
							height: 180px;
						}
						.img4 {
							top: 200px;
							left: 340px;
							width: 240px;
							height: 240px;
						}
					}
					.ry-fl-s {
						width: calc(100% - 650px);
						display: flex;
						color: white;
						font-size: 22px;
						.item {
							width: 100%;
							margin-bottom: 50px;
							div {
								padding-left: 20px;
								font-size: 18px;
							}
						}
					}
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
			.zp-hire {
				width: 100%;
				// height: 300px;
				display: flex;
		
				img {
					width: 100%;
					// min-height: 300px;
					height: auto;
				}
				
		
				div {
					font-weight: 400;
					font-size: 30px;
					z-index: 3;
				}
			}
		
		    .jr {
				width: 100%;
				// height: 230px;
				display: flex;
				padding:30px 0;
				.jr-h {
					font-size: 30px;
				}
				.jr-b {
					width: 140px;
					height: 50px;
					margin-top: 28px;
					border-radius: 25px;
					line-height: 50px;
				}
			}
		
		    // 资质荣誉
		    .gz {
		    	width: 100%;
		    	display: flex;
		    	padding-bottom: 60px;
				
				.gz-h {
					width: 100%;
					height: 150px;
					line-height: 150px;
					font-size: 22px;
				}
		    
		    	.gz-c {
		    		width: 100%;
					display: flex;
					.gz-c-l, .gz-c-r {
						width: 50px;
						height: 50px;
					}
					.gz-c-m {
						width: calc(100% - 140px);
						display: flex;
						.item {
							width: 48%;
							border-radius: 10px;
							padding: 30px 30px 60px;
							.item-h {
								display: flex;
								img {
									width: 55px;
									height: 55px;
									border-radius: 27px;
								}
								div {
									font-size: 19px;
									margin-left: 20px;
									width: calc(100% - 70px);
								}
							}
							.item-f {
								font-size: 14px;
								margin-left: 70px;
								width: calc(100% - 70px);
								margin-bottom: 18px;
							}
							.item-h-img {
								width: 30px;
								width: 30px;
								position: absolute;
								bottom: 30px;
								right: 30px;
							}
						}
					}
					
					
		    	}
			}
			.ry {
				width: 100%;
				height: 650px;
			    .ry-h {
			    	width: 100%;
			    	height: 130px;
			    	line-height: 130px;
			    	font-weight: 500;
			    	font-size: 22px;
			    }
				.ry-fl {
					width: 100%;
					margin: 0 auto;
					justify-content: space-between;
					
					.ry-fl-img {
						width: 550px;
						height: 360px;
						.img1 {
							top: 18px;
							left: 50px;
							width: 200px;
							height: 200px;
						}
						.img2 {
							top: 0px;
							left: 280px;
							width: 150px;
							height: 150px;
						}
						.img3 {
							top: 240px;
							left: 140px;
							width: 150px;
							height: 150px;
						}
						.img4 {
							top: 170px;
							left: 320px;
							width: 200px;
							height: 200px;
						}
					}
					.ry-fl-s {
						width: calc(100% - 580px);
						display: flex;
						color: white;
						font-size: 18px;
						.item {
							width: 100%;
							margin-bottom: 50px;
							div {
								padding-left: 20px;
								font-size: 15px;
							}
						}
					}
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px;
			.zp-hire {
				width: 100%;
				// height: 240px;
				display: flex;
		
				img {
					width: 100%;
					// height: 240px;
					// min-height: 240px;
					height: auto;
				}
		
				div {
					font-weight: 400;
					font-size: 20px;
					z-index: 3;
				}
			}
		
		    .jr {
				width: 100%;
				// height: 190px;
				display: flex;
				padding:20px 0;
				.jr-h {
					font-size: 20px;
				}
				.jr-b {
					width: 100px;
					height: 40px;
					margin-top: 20px;
					border-radius: 20px;
					line-height: 40px;
				}
			}
		
		    // 资质荣誉
		    .gz {
		    	width: 100%;
		    	display: flex;
		    	padding-bottom: 30px;
				
				.gz-h {
					width: 100%;
					height: 120px;
					line-height: 120px;
					font-size: 19px;
				}
		    
		    	.gz-c {
		    		width: 100%;
					display: flex;
					flex-direction: column;
					.gz-c-l, .gz-c-r {
						display: none;
					}
					.gz-c-m {
						width: 100%;
						padding: 0 14px;
						display: flex;
						.item {
							width: 48%;
							border-radius: 5px;
							padding: 15px 15px 30px;
							.item-h {
								display: flex;
								img {
									width: 30px;
									height: 30px;
									border-radius: 15px;
								}
								div {
									font-size: 16px;
									margin-left: 10px;
									width: calc(100% - 40px);
								}
							}
							.item-f {
								font-size: 13px;
								margin-left: 40px;
								width: calc(100% - 40px);
								margin-bottom: 12px;
							}
							
							.item-h-img {
								width: 15px;
								width: 15px;
								position: absolute;
								bottom: 15px;
								right: 15px;
							}
						}
					}
					
					
		    	}
			}
			.ry {
				width: 100%;
				height: 360px;
			    .ry-h {
			    	width: 100%;
			    	height: 120px;
			    	line-height: 120px;
			    	font-weight: 500;
			    	font-size: 19px;
			    }
				
				
				.ry-fl {
					width: 100%;
					margin: 0 auto;
					justify-content: space-between;
					
					.ry-fl-img {
						width: 100%;
						height: 360px;
						display: none;
					}
					.ry-fl-s {
						width: 100%;
						display: flex;
						color: white;
						font-size: 17px;
						padding-left: 16px;
						.item {
							width: 100%;
							margin-bottom: 30px;
							div {
								padding-left: 16px;
								font-size: 14px;
							}
						}
					}
				}
			}
		}
		
		.expandable-table{
			th{
				padding:0 6px !important;
				&:nth-child(5){
					width:50px;
				}
				&:nth-child(6){
					width:30px;
				}
				&:nth-child(1){
					width:30px;
				}
				&:nth-child(7){
					width:35px;
				}
				&:nth-child(4){
					width:50px;
				}
				&:nth-child(2){
					width:50px;
				}
			}
			tr{
				td{
					word-break: break-word;
				}
			}
		}
	
	}
	

.zw-table-wrap{
	max-width:1200px;
	width:100%;
	margin-top:15px;
	padding:0 4px;
}

.expandable-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  border: 1px solid #22A3D3;
}

.expandable-table tr{
	cursor:pointer;
	td{
		padding: 16px 0;
		text-align: center;
	}
	&.zw-tr-selected{
		background:#22A3D3;
		td{
			color:white !important;
			button{
				color:white !important;
			}
		}
	}
}

.expandable-table tr.simple-intro:hover{
	background:#22A3D3;
	td{
		button{
			color:white !important;
		}
	}
	color:white !important;
}

.expandable-table th{
	padding: 16px 0;
	text-align: center;
} 


.expandable-table thead tr{
  background-color: #22A3D3;
  padding:16px 0;
  
  color:white;
}

.detail-row {
  background-color: #f9f9f9;
}

.detail-content {
  padding: 10px 20px;
  text-align:left;
  
}

.expandable-table td button {
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size:24px;
  padding:0;
  background:none;
  width:26px;
  height:26px;
  color:#aaa;
  &.button-jian{
	  font-size:20px;
  }
}

.expandable-table td button:hover {
  
}	
	
	
</style>
